import http from '../../../../../libs/http'
export default (payload = {}) => http.post(`${process.env.VUE_APP_MICROSERVICE_API_PUBLICACIONES}`, payload, { loading: true })
